import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VideoSpot } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { YoutubePlayerComponent } from '@features/video-player/youtube-player/youtube-player.component';

import { VimeoPlayerComponent } from '@features/video-player/vimeo-player/vimeo-player.component';

@Component({
    selector: 'app-video-spot',
    templateUrl: './video-spot.component.html',
    styleUrls: ['./video-spot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [YoutubePlayerComponent, VimeoPlayerComponent]
})
export class VideoSpotComponent {
    public static readonly ref: string = 'video';

    @Input()
    public data: VideoSpot;
}
